import { Settings } from 'lucide-react';

import { FullPageState } from '@/features/auth/components/full-page-state';
import { AuthProvider } from '@/features/auth/auth-provider';
import { EnvValidationError, getEnv } from '@/lib/env';

import { AppProviders } from './providers/app-providers';
import { AppRouter } from './router/app-router';

function readConfigurationError(): string[] | null {
  try {
    getEnv();
    return null;
  } catch (error) {
    return error instanceof EnvValidationError ? error.issues : ['Configuración inválida.'];
  }
}

export function App() {
  const configurationIssues = readConfigurationError();
  if (configurationIssues) {
    return (
      <FullPageState
        tone="danger"
        icon={Settings}
        title="La aplicación no está configurada"
        description={
          <>
            Revisa las variables de entorno (<code>.env.local</code>):
            <ul className="mt-3 list-inside list-disc text-left">
              {configurationIssues.map((issue) => (
                <li key={issue}>{issue}</li>
              ))}
            </ul>
          </>
        }
      />
    );
  }

  return (
    <AppProviders>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </AppProviders>
  );
}
